import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PupilService } from '@app/student/services/pupil.service';
import { MAIN_DOMAIN } from '@app/app.constants';
import { Answer, CardInterface } from '@app/definitions/interfaces';

@Component({
    selector: 'app-pupil-magic-box-exercise',
    templateUrl: './pupil-magic-box-exercise.component.html',
    styleUrls: ['./pupil-magic-box-exercise.component.scss']
})
export class PupilMagicBoxExerciseComponent implements OnInit {
    @Input() exercise;
    @Input() selectedExerciseIndex: number;
    @Input() studentId: number;
    @Input() cardId: number;
    @Input() card: CardInterface;
    @Input() isFinishCard: boolean = false;

    @Output() answered = new EventEmitter();
    @Output() exerciseCompleted = new EventEmitter();
    @Output() exerciseCorrect = new EventEmitter();
    answer_array: Array<any>;
    exercise_body: Array<any>;
    student_answer_array: Array<any>;
    answerStr: string = '';
    old_answer: Answer;
    buttons: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    selectedCellCoord: Array<number> = [];
    errorMessage: string;
    riskCharacterSelected: boolean = false;
    main_domain = MAIN_DOMAIN;

    constructor(private pupilSvc: PupilService) {}

    ngOnInit() {
        this.exercise_body = JSON.parse(this.exercise.text);
        this.answer_array = JSON.parse(this.exercise.answers[0].shortAnswer);
        if (this.old_answer) {
            this.student_answer_array = JSON.parse(this.old_answer.shortAnswer);
            this.answerStr = this.old_answer.shortAnswer;
        } else {
            this.student_answer_array = JSON.parse(this.exercise.text);
        }
        this.riskCharacterSelected = this.pupilSvc.getRiskCharacter();
    }

    selectCell(row_index: number, elem_index: number) {
        this.selectedCellCoord = [];
        this.selectedCellCoord.push(row_index);
        this.selectedCellCoord.push(elem_index);
    }

    keyboardClicked(button: number | string) {
        let answr;
        const correct_cell = this.answer_array[this.selectedCellCoord[0]][this.selectedCellCoord[1]];
        const student_cell = this.student_answer_array[this.selectedCellCoord[0]][this.selectedCellCoord[1]];
        let answ_str: string;
        if (typeof correct_cell === 'number') {
            if (student_cell) {
                answ_str = student_cell.toString();
            } else {
                answ_str = '';
            }
            answ_str = answ_str + button.toString();
            answr = +answ_str;
        } else {
            if (student_cell) {
                answ_str = student_cell;
            } else {
                answ_str = '';
            }
            answ_str = answ_str + ', ' + button;
            answr = answ_str;
        }
        this.student_answer_array[this.selectedCellCoord[0]][this.selectedCellCoord[1]] = answr;
        this.answerStr = JSON.stringify(this.student_answer_array);
    }

    checkIfCellChosen(row, col) {
        if (row === this.selectedCellCoord[0] && col === this.selectedCellCoord[1]) {
            return 'cell_border';
        } else {
            return '';
        }
    }

    compareWithAnswer() {
        return this.answerStr === JSON.stringify(this.answer_array);
    }

    checkAnswer() {
        if (this.answerStr === '') {
            this.errorMessage = 'Вы должны ввести ответ или нажать "назад".';
            return;
        }
        this.errorMessage = null;
        const correctExercise: boolean = this.compareWithAnswer();
        const exerciseAnswer: Answer = {
            student: this.studentId,
            card: this.cardId,
            shortAnswer: this.answerStr,
            exercise: this.exercise.id,
            correct: correctExercise
        };

        this.clearAnswer();
        this.answered.emit(exerciseAnswer);
        this.exerciseCompleted.emit(true);
        this.exerciseCorrect.emit(correctExercise);
    }

    clearAnswer() {
        this.answerStr = '';
        this.student_answer_array = JSON.parse(this.exercise.text);
    }

    clearCell(row_index: number, elem_index: number) {
        this.selectedCellCoord = [];
        this.selectedCellCoord.push(row_index);
        this.selectedCellCoord.push(elem_index);
        this.student_answer_array[this.selectedCellCoord[0]][this.selectedCellCoord[1]] = '';
        this.answerStr = JSON.stringify(this.student_answer_array);
    }
}
